import { keepPreviousData, QueryClient } from '@tanstack/react-query';

// ADR-006: defaults del layer dati.
// - `staleTime` 60s: rivisitare una pagina entro il minuto non rifà la fetch;
//   gli hook con dato più volatile lo abbassano localmente.
// - `gcTime` 10 min: la cache di una pagina lasciata sopravvive a un giro
//   altrove e torna istantanea.
// - `placeholderData: keepPreviousData`: quando un hook già montato cambia
//   query key (selettore di periodo/mese, picker di configurazione) tiene i
//   dati precedenti finché arrivano i nuovi, invece di sbattere sullo spinner.
// - `retry: 1`: il Worker su piano free fa cold start; tre tentativi rendevano
//   lentissimi anche gli errori legittimi.
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			staleTime: 60_000,
			gcTime: 10 * 60_000,
			placeholderData: keepPreviousData,
			retry: 1,
		},
	},
});

/**
 * Utente a cui appartiene la cache. Quando cambia (uscita, o un altro account
 * nella stessa scheda) la cache si svuota: le chiavi sono per organizzazione,
 * non per utente, e un socio entrato dopo il superadmin vedeva i dati salvati
 * per lui — i nomi dei soci senza consenso compresi (INB-357, INB-354).
 */
let cacheOwner: string | null | undefined;

export function syncQueryCacheOwner(userId: string | null): void {
	if (cacheOwner !== undefined && cacheOwner !== userId) queryClient.clear();
	cacheOwner = userId;
}
